import { TLanguagesKeys, TLocaleConfigurations } from "@ob/i18n";
import { itIT } from "@mui/x-date-pickers/locales";
import it from "date-fns/locale/it";

export const DEFAULT_LANGUAGE: TLanguagesKeys = "it";

export const localeConfigurations: TLocaleConfigurations = {
  it: {
    locale: it,
    dateFormat: "dd/MM/yyyy",
    dateFieldLocaleText:
      itIT.components.MuiLocalizationProvider.defaultProps.localeText,
  },
};
